'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _CloseIcon = require('../../icons/CloseIcon');

var _CloseIcon2 = _interopRequireDefault(_CloseIcon);

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

var _shallowEqual = require('../../utils/shallowEqual');

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Toast = function (_Component) {
  _inherits(Toast, _Component);

  function Toast() {
    _classCallCheck(this, Toast);

    // track mouse enter/leave events
    // so we dont dismiss a toast if user is currently hovering
    var _this = _possibleConstructorReturn(this, (Toast.__proto__ || Object.getPrototypeOf(Toast)).call(this));

    _this.state = {
      mouseOver: false,
      mouseLeaveDismiss: false
    };

    _this.handleDismiss = _this.handleDismiss.bind(_this);
    _this.handleAction = _this.handleAction.bind(_this);
    _this.onMouseEnter = _this.onMouseEnter.bind(_this);
    _this.onMouseLeave = _this.onMouseLeave.bind(_this);
    return _this;
  }

  _createClass(Toast, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setAutoHideTimer();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      // we only care about props updating
      return !(0, _shallowEqual2.default)(this.props, nextProps);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.setAutoHideTimer();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._autoHideId);
    }
  }, {
    key: 'setAutoHideTimer',
    value: function setAutoHideTimer() {
      var _this2 = this;

      // reset mouse leave dismiss
      this.setState({
        mouseLeaveDismiss: false
      });

      if (this.props.autoHideDuration && this.props.autoHideDuration > 0) {
        clearTimeout(this._autoHideId);
        this._autoHideId = setTimeout(function () {
          // if mouse is currently over, dont dismiss on timeout
          if (!_this2.state.mouseOver) {
            _this2.handleDismiss();
          } else {
            _this2.setState({
              mouseLeaveDismiss: true
            });
          }
        }, this.props.autoHideDuration);
      }
    }
  }, {
    key: 'onMouseEnter',
    value: function onMouseEnter() {
      this.setState({
        mouseOver: true
      });
    }
  }, {
    key: 'onMouseLeave',
    value: function onMouseLeave() {
      // dismiss if timeout hit but user was hovering
      if (this.state.mouseLeaveDismiss) {
        this.handleDismiss();
      }

      this.setState({
        mouseOver: false
      });
    }
  }, {
    key: 'handleDismiss',
    value: function handleDismiss() {
      this.props.onDismiss();
    }
  }, {
    key: 'handleAction',
    value: function handleAction() {
      this.props.action.handler();
      this.props.onDismiss();
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var toastClass = (0, _classnames3.default)((_classnames = {}, _defineProperty(_classnames, _styles2.default['toast--default'], this.props.type === 'default'), _defineProperty(_classnames, _styles2.default['toast--loading'], this.props.type === 'loading'), _defineProperty(_classnames, _styles2.default['toast--success'], this.props.type === 'success'), _defineProperty(_classnames, _styles2.default['toast--error'], this.props.type === 'error'), _classnames));

      var action = this.props.action && _react2.default.createElement(
        'span',
        {
          onClick: this.handleAction,
          className: _styles2.default.toast__action,
          'data-hudl-element': this.props.identifier + '-action'
        },
        this.props.action.text
      );

      var title = this.props.title ? _react2.default.createElement(
        'h4',
        { className: _styles2.default.toast__title },
        this.props.title
      ) : null;

      var dismiss = this.props.type !== 'loading' ? _react2.default.createElement(
        'span',
        { className: _styles2.default['toast__dismiss-button'],
          onClick: this.handleDismiss,
          'data-hudl-element': 'toast-dismiss-action'
        },
        _react2.default.createElement(_CloseIcon2.default, { className: _styles2.default['toast__dismiss-icon'], size: 'small' })
      ) : null;

      return _react2.default.createElement(
        'div',
        {
          className: toastClass,
          onMouseEnter: this.onMouseEnter,
          onMouseLeave: this.onMouseLeave,
          'data-hudl-element': this.props.identifier
        },
        _react2.default.createElement(
          'div',
          { className: _styles2.default.toast__content },
          title,
          _react2.default.createElement(
            'p',
            { className: _styles2.default.toast__message },
            this.props.message,
            action
          )
        ),
        dismiss
      );
    }
  }]);

  return Toast;
}(_react.Component);

Toast.propTypes = {
  /*
   * String used in the data-hudl-element attribute of the containing div
   */
  identifier: _react.PropTypes.string,
  /*
   * String determining style and behavior of the Toast
   */
  type: _react.PropTypes.oneOf(['default', 'loading', 'success', 'error']).isRequired,
  /*
   * Primary text content
   */
  message: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]).isRequired,
  /*
   * Optional title string
   */
  title: _react.PropTypes.string,
  /*
   * The number of milliseconds to wait before automatically dismissing
   */
  autoHideDuration: _react.PropTypes.number,
  /*
   * Action (text and handler function) to append to message
   */
  action: _react.PropTypes.shape({
    text: _react.PropTypes.string,
    handler: _react.PropTypes.func
  }),
  /*
   * Function to handle dismissing the Toast
   */
  onDismiss: _react.PropTypes.func.isRequired
};
Toast.defaultProps = {
  autoHideDuration: 0
};
exports.default = Toast;